import { Pipe, PipeTransform } from '@angular/core';
import { StatusCabecalhoPedidoDeCarga as Status } from '../../models/pedido-de-carga/StatusCabecalhoPedidoDeCarga';

@Pipe({
  name: 'statusCabecalhoPedidoCarga',
})
export class StatusCabecalhoPedidoCargaPipe implements PipeTransform {
  transform(status: Status): string {
    return {
      [Status.Calculado]: 'Calculado',
      [Status.Verificado]: 'Verificado',
      [Status.FalhaNaComunicacaoAPI]: 'Falha Na Comunicação (API)',
      [Status.PedidoComCriticaAPI]: 'Pedido Com Crítica (API)',
      [Status.PedidoRealizadoAPI]: 'Pedido Realizado (API)',
      [Status.PedidoCancelado]: 'Pedido Cancelado',
      [Status.PedidoRealizadoArquivoGerado]: 'Arquivo Gerado',
    }[status];
  }
}
